// removed by extract-text-webpack-plugin
module.exports = {"settings":"Settings-module__settings___2bu-2","hidden":"Settings-module__hidden___2FGed","previewField":"Settings-module__previewField___1wwXt","previewInput":"Settings-module__previewInput___FAyGt","preview":"Settings-module__preview___38UF3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/Settings.module.sass
// module id = 1039
// module chunks = 0